<template>
  <div>
    <b-modal
      v-model="showModalSvg"
      size="lg"
      centered
      body-class="p-0"
      hide-footer
    >
      <span slot="modal-title">
        <small>{{ venueMapBlock ? 'Selecciona un sector' : 'Selecciona tus asientos' }} </small>
      </span>
      <div>
        <div class="modal-body p-0">
          <button
            v-if="!venueMapBlock && svgBlocks.length > 1"
            @click="toSvgGeneral()"
            type="button"
            class="btn btn-secondary btn-sm btn-back-svg"
          >
            Ver plano general
          </button>
          <svg-blocks
            v-if="venueMapBlock"
            ref="svgBlocks"
            :svg-html="eventData.venueSvgStructure"
            @on-select-block="onSelectBlock"
          ></svg-blocks>
          <svg-seats
            v-else
            ref="svgSeats"
            v-model="seatsSelect"
            :svg-html="svgUrl"
            @on-verify-seat="onSelectSeat"
            @update-seat="updateSeat"
          ></svg-seats>
          <div v-if="loading" class="svg-loading">
            <span class="material-icons animation-spin">scatter_plot</span>
            <div class="ml-3">Validando disponibilidad...</div>
          </div>
          <div v-if="seatMultiple" class="multi-types">
            <div class="multi-types__body">
              <div class="p-3">
                <button
                  @click="seatMultiple = null"
                  type="button"
                  class="close px-2"
                >
                  &times;
                </button>
                <h5 class="mb-4">
                  <b>Seleccione el tipo de entrada</b>
                </h5>
                <div>
                  <b>*Recuerda:</b>
                  <div class="mb-2 small">
                    En el ingreso se realizará la verificación del tipo de entrada con su
                    carné respectivo. Si no cuenta con el carné se le negará el ingreso.
                  </div>
                  <div class="mb-2 small">
                    Si no cuenta con el carné respectivo seleccione general.
                  </div>
                </div>
              </div>
              <div class="list-group mb-3">
                <button
                  v-for="type in seatMultiple"
                  :key="type.id"
                  type="button"
                  @click="onSelectMultiType(type)"
                  class="list-group-item list-group-item-action"
                >
                  <span class="row">
                    <span class="col-4">
                      {{ type.name }}
                    </span>
                    <span class="col-4">
                      <b>Precio: {{ currency }} </b>
                      <b>{{ type.price }}</b>
                    </span>
                    <span class="col-4 text-right">
                      Seleccionar
                    </span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-legend">
          <div class="row align-items-center px-3">
            <div class="col-12">
              <div class="d-flex justify-content-between align-items-center py-3">
                <span class="d-flex align-items-center">
                  <i class="material-icons">radio_button_unchecked</i>
                  <small class="ml-1">Libres</small>
                </span>
                <span class="d-flex align-items-center">
                  <i class="material-icons text-danger">lens</i>
                  <small class="ml-1">Seleccionado</small>
                </span>
                <span class="d-flex align-items-center">
                  <i class="material-icons text-muted">lens</i>
                  <small class="ml-1">No disponibles</small>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import api from '../api';

export default {
  data() {
    return {
      loading: false,
      loaded: false,
      showModalSvg: false,
      venueMapBlock: true,
      eventData: {},
      currentHour: {},
      currentType: {},
      seatsSelect: {},
      svgBlock: {},
      svgUrl: null,
      currentSeat: {},
      seatMultiple: null,
    };
  },
  computed: {
    svgBlocks() {
      return JSON.parse(this.eventData.venueBlockStructure);
    },
    typesIds() {
      return this.currentHour.types.map(el => el.ticketTypeId).join(',');
    },
    currency() {
      return this.eventData.currency === 'PEN' ? 'S/' : '$';
    },
  },
  methods: {
    init(hour, type) {
      this.currentHour = hour;
      this.currentType = type;
      // this.seatsSelect = {};
      this.venueMapBlock = true;
      this.showModalSvg = true;
      this.getInitData();
    },
    onSelectBlock(data) {
      const self = this;
      const blockObj = this.svgBlocks.find(i => i.id === data.id);
      this.svgBlock = blockObj;
      this.svgUrl = blockObj.path;
      this.venueMapBlock = false;
      this.loading = true;
      setTimeout(() => {
        self.verifySeats(data);
      }, 500);
    },
    async onSelectSeat(data) {
      const payload = {
        activityId: this.eventData.activity_id,
        dateHourId: this.currentType.adhId,
        typesAvailable: this.typesIds,
        seat: data.id,
      };
      this.loading = true;
      this.currentSeat = data;
      const res = await api.seatVerifyAndReserved(payload);
      this.loading = false;
      if (res.available) {
        if (res.types.length > 1) {
          this.seatMultiple = res.types;
        } else {
          // eslint-disable-next-line
          data.type = res.types[0].id;
          this.setSeatVerify(true, data);
        }
      } else {
        this.setSeatVerify(false, data);
      }
    },
    onSelectMultiType(type) {
      this.currentSeat.type = type.id;
      this.setSeatVerify(true, this.currentSeat);
    },
    setSeatVerify(available, data) {
      this.seatMultiple = '';
      this.$refs.svgSeats.setSeatVerify(available, data);
    },
    updateSeat({ isRemove, type, id }) {
      const arrSeats = Object.values(this.seatsSelect);
      const arrVal = arrSeats.filter(item => item.type === type).map(i => i.id);
      const ticketType = this.currentHour.types.find(obj => obj.ticketTypeId === type);

      if (arrVal.length > ticketType.maxQuantityPerOrder) {
        this.$refs.svgSeats.updateSeat(id);
        // eslint-disable-next-line
        alert('No puedes comprar más entradas de este tipo para esta fecha y horario!');
        return;
      }
      ticketType.value = arrVal.join();
      this.addEventToCart(ticketType, isRemove);
    },
    addEventToCart(ticketType, isRemove) {
      this.$emit('add-cart', ticketType, isRemove);
    },
    // fns
    toSvgGeneral() {
      const self = this;
      this.venueMapBlock = true;
      setTimeout(() => {
        self.$refs.svgBlocks.init();
      }, 200);
    },
    verifySeats() {
      const { currentType, $refs } = this;
      const payload = {
        typesAvailable: this.typesIds,
        venueId: this.eventData.idVenue,
        activityId: this.eventData.activity_id,
        dateHourId: this.currentType.adhId,
        blockId: this.svgBlock.id,
      };
      const payloadBuyed = {
        activityId: this.eventData.activity_id,
        dateHourId: this.currentType.adhId,
      };
      $refs.svgSeats.init(async () => {
        // free seats
        const seatsFree = await api.getSeatsStringByBlockId(payload);
        const arrAll = seatsFree.map(item => item.seats);
        if (!arrAll.length) {
          this.loading = false;
          this.toSvgGeneral();
          return;
        }
        const arr = arrAll.join().split(',');
        const arrSeats = arr.map(item => ({ id: item }));
        this.$refs.svgSeats.enableSeats(arrSeats);

        // buyed seats
        const seatsBuyed = await api.getSeatsBuyed(payloadBuyed);
        const arrSeatsBuyed = seatsBuyed.map(i => i.position || 'undefined');
        this.$refs.svgSeats.disableSeats(arrSeatsBuyed);

        // active prev select
        if (currentType.value) {
          const prevSeats = currentType.value.split(',').map(seat => ({
            id: seat,
            type: currentType.ticketTypeId,
          }));
          $refs.svgSeats.selectToggleSeats(prevSeats);
        }
        // end init svg
        this.loading = false;
      });
    },
    async getInitData() {
      const self = this;
      this.loading = true;
      const data = await api.getDataEvent(this.currentType.activityId);
      if (!data) {
        this.showModalSvg = false;
      }
      this.eventData = data.eventData;
      this.loading = false;
      this.loaded = true;
      if (this.svgBlocks.length > 1) {
        this.venueMapBlock = true;
        setTimeout(() => {
          self.$refs.svgBlocks.init();
        }, 200);
      } else {
        this.onSelectBlock({
          id: this.svgBlocks[0].id,
          type: this.currentType.ticketTypeId,
        });
      }
    },
  },
};
</script>

<style lang="scss">
.btn-back-svg{
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
}

.svg-loading{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(#fff, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-legend{
  border-top: 1px solid #ddd;
}
</style>
